import SlideFrame from '../assets/images/ProjectSlide.svg';
import UIUXIcon from '../assets/images/UIUXIcon.svg';
import DevIcon from '../assets/images/DevIcon.svg';
import LinkObjectIcon from '../assets/images/LinkObjectIcon.svg';
import Image from './Image';
import BasicText from './BasicText';
import type { PortfolioProject } from '@/data/portfolio';

// One easing for every moving part so the hover reads as a single motion.
// Transform-based movement is gated behind motion-safe; opacity fades always run.
const EASE = 'transition-all duration-500 ease-[cubic-bezier(0.22,1,0.36,1)]';

function ProjectSlide({ descrip, link, preview, blueLogo, miniLogo, logoText }: PortfolioProject) {
  return (
    <div className='w-full flex flex-row justify-center'>
      <a href={link} target="_blank" rel="noopener noreferrer" className='group w-full max-w-[500px]'>
        <div className='relative w-full flex flex-col gap-[15px]'>
          <div className='relative w-full aspect-[500/304]'>
            <div className={`absolute inset-0 from-[#0A0A12BF] to-[#0A0A12] bg-gradient-to-b z-[20] opacity-100 group-hover:opacity-0 ${EASE}`} />
            <div className='absolute inset-0 z-[30]'>
              <Image src={SlideFrame} alt='' className='w-full' />
            </div>
            {/* Same outline as the frame, in brand blue, faded in on hover. */}
            <svg
              viewBox="0 0 587 358"
              fill="none"
              aria-hidden="true"
              className={`absolute inset-0 w-full h-full z-[30] pointer-events-none opacity-0 group-hover:opacity-100 drop-shadow-[0_0_10px_rgba(54,141,255,0.45)] ${EASE}`}
            >
              <path
                d="M0.625 35.2799L39.4489 0.625H586.375V357.375H0.625V35.2799Z"
                stroke="#368DFF"
                strokeOpacity="0.7"
                strokeWidth="1.25"
                vectorEffect="non-scaling-stroke"
              />
            </svg>
            <div className='absolute inset-x-[8%] bottom-[1px] z-[10]'>
              <Image src={preview} alt='' loading='lazy' decoding='async' className={`w-full origin-bottom motion-safe:group-hover:scale-[1.04] ${EASE}`} />
            </div>
            <div className={`absolute inset-0 flex items-center justify-center z-[40] pointer-events-none opacity-100 group-hover:opacity-0 motion-safe:group-hover:scale-95 ${EASE}`}>
              <Image src={blueLogo} alt='' className='h-[32px] sm:h-[40px] w-auto' />
            </div>
            <div className='absolute top-[36px] left-[36px] z-[40]'>
              <div className='w-[6px] h-[6px] bg-[#2589FF] border-[2px] border-[#000000]' />
            </div>
            <div className={`absolute top-[38px] right-[38px] z-[40] motion-safe:group-hover:translate-x-[10px] motion-safe:group-hover:-translate-y-[10px] ${EASE}`}>
              <Image src={LinkObjectIcon} alt='' />
            </div>
            <div className={`absolute flex flex-row items-center justify-end bottom-[40px] right-[40px] z-[40] gap-[8px] opacity-100 group-hover:opacity-0 motion-safe:group-hover:translate-y-[6px] ${EASE}`}>
              <div className='h-[33px] flex flex-row items-center justify-start gap-[8px] px-[8px] border-[1.25px] border-[#22222F99] backdrop-blur-sm shadow-inner shadow-[#2589FF0D]'>
                <div>
                  <Image src={DevIcon} alt='' />
                </div>
                <div>
                  <BasicText variant='basic'>
                    Frontend Dev
                  </BasicText>
                </div>
              </div>
              <div className='h-[33px] flex flex-row items-center justify-start gap-[8px] px-[8px] border-[1.25px] border-[#22222F99] backdrop-blur-sm shadow-inner shadow-[#2589FF0D]'>
                <div>
                  <Image src={UIUXIcon} alt='' />
                </div>
                <div>
                  <BasicText variant='basic'>
                    UI/UX
                  </BasicText>
                </div>
              </div>
            </div>
          </div>
          <div className='flex flex-row items-center gap-[8px]'>
            <Image src={miniLogo} width={28} height={28} alt='' />
            <div>
              <BasicText size='16px' className={`group-hover:text-luminode-blue ${EASE}`}>
                {logoText}
              </BasicText>
            </div>
          </div>
          <div className={`text-[20px] xl:text-[24px] font-medium font-geist-mono max-w-[290px] text-white`}
          >
            {descrip}
          </div>
        </div>
      </a>
    </div>
  );
}

export default ProjectSlide;
